export default __webpack_public_path__ + "static/media/img_home_2.e318f044.png";